module.exports = __webpack_public_path__ + "img/5.cleaned_mirro.14441f79.svg";